'use client';

import { List } from '@coolblue-development/freddy';
import { Checkmark, Insurance as InsuranceIcon } from '@coolblue-development/icons';
import styled from '@emotion/styled';

const StyledUspsList = styled(List)(({ theme }) => ({
  '& li': {
    marginTop: theme.spacing[100]
  }
}));

const GreenCheckmark = styled(Checkmark)(({ theme }) => ({
  fill: theme.color.icon.sentimentPositive
}));

const BlueInsuranceIcon = styled(InsuranceIcon)(({ theme }) => ({
  fill: theme.color.icon.base
}));

const StyledUsefulLinksList = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,

  [theme.breakpoint.minWidth('md')]: {
    display: 'flex',

    '& li + li': {
      marginLeft: theme.spacing[400],
      paddingLeft: theme.spacing[400],
      borderLeft: `${theme.borderWidth[25]} solid ${theme.color.border.base}`
    }
  }
}));

export { BlueInsuranceIcon, GreenCheckmark, StyledUsefulLinksList, StyledUspsList };
